import { Flag02Icon } from '@hugeicons-pro/core-solid-rounded';
import cn from 'classnames';
import { FLAG_SEVERITY_MAP, FLAG_SEVERITY_ORDER } from 'constants/forms';
import { useTranslation } from 'react-i18next';

import StatusPill from 'components/Pills/StatusPills';

export const SEVERITY_ICON_COLORS = {
  high: 'text-red-2',
  medium: 'text-orange-2',
  low: 'text-blue-3',
};

export const FlagSeverityCounts = ({ counts, label, className }) => {
  const { t } = useTranslation();
  const present = FLAG_SEVERITY_ORDER.filter(severity => counts?.[severity] > 0);

  if (present.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      {label && <span className="text-lg text-text-tertiary">{label}:</span>}
      {present.map(severity => (
        <StatusPill
          key={severity}
          status={FLAG_SEVERITY_MAP[severity].status}
          text={counts[severity] + ' ' + t('flagSeverity.' + severity)}
          className="text-uppercase"
          small
          noBorder
          lightBackground
          icon={Flag02Icon}
          iconSize="12"
          iconColor={SEVERITY_ICON_COLORS[severity]}
        />
      ))}
    </div>
  );
};
